import { Divider, Stack, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

import FHConfirmDialog from '../../../../../../components/base/dialogs/FHConfirmDialog';
import { FORTA_SUCCESS } from '../../../../../../utils/colors';

import type { ConcludeSuccessModalProps } from './types';

function renderTitle() {
  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <CheckCircleRoundedIcon sx={{ color: FORTA_SUCCESS }} />
        <Typography variant="h4" fontWeight={500}>
          Confirmation
        </Typography>
      </Stack>
      <Divider sx={{ mt: 2 }} />
    </>
  );
}

function renderContent() {
  return (
    <Stack spacing={2} sx={{ pt: 3 }}>
      <Typography sx={{ fontWeight: 'bold' }}>
        Your Client Onboarding was submitted successfully.
      </Typography>
      <Typography sx={{ fontWeight: 'bold' }}>Thank you!</Typography>
    </Stack>
  );
}

export default function ConcludeSuccessModal({ open, onClose }: ConcludeSuccessModalProps) {
  return (
    <FHConfirmDialog
      open={open}
      hideCloseIcon
      hideCancelButton
      submittext="Done"
      onClose={onClose}
      // "Done" only dismisses; there is no distinct submit action on this success modal.
      onSubmit={onClose}
      dialogHeight="auto"
      footerContainerStyles={{ mt: 4 }}
      submitBtnTestId="conclude-success-done"
      titleRenderer={renderTitle}
      contentRenderer={renderContent}
    />
  );
}
